import { createPortal } from "react-dom";
import { useTopDiscardPrompt } from "@/lib/discard-guard";

/** The one "Discard changes?" dialog for every guarded form (see
 *  lib/discard-guard.ts). Mounted once in App; shows the top prompt. */
export function DiscardConfirmHost() {
  const p = useTopDiscardPrompt();
  if (!p) return null;
  return createPortal(
    <div
      className="af-confirm-backdrop"
      style={{ zIndex: 5000 }}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="af-confirm" role="alertdialog" aria-modal="true">
        <div className="af-confirm-title">{p.title ?? "Discard changes?"}</div>
        <div className="af-confirm-text">
          {p.text ?? "Changes you made here have not been saved yet."}
        </div>
        <div className="af-confirm-actions">
          <button type="button" className="af-btn danger" onClick={p.discard}>
            Discard
          </button>
          <button type="button" className="af-btn primary" onClick={p.keep} autoFocus>
            Keep editing
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
